export const ALL_PERMISSION_KEYS = [
  "create_boq",
  "pending_po",
  "rep_pending_po",
  "rfd_po",
  "clients",
  "sku",
  "site_config",
  "ongoing_sites",
  "dispatch_dc",
  "tasks",
  "pending_payments",
  "payments",
  "petty_cash",
  "accounts",
  "account_settlement_gst",
  "account_settlement_gst_add",
  "account_settlement_gst_exclude",
  "account_settlement_gst_delete",
  "account_settlement_cp",
  "account_settlement_cp_add",
  "account_settlement_cp_exclude",
  "account_settlement_cp_delete",
  "sales_report",
  "catalogue",
  "drive",
  "upload_catalogue",
  "upload_drawings",
  "user_management",
  "ongoing_sites_assigned_only",
  "site_visits",
  "site_visits_self_only",
  "site_visits_edit_own",
  "site_visits_edit_all",
] as const;

export type PermissionKey = (typeof ALL_PERMISSION_KEYS)[number];
export type UserPermissions = Record<PermissionKey, boolean>;

export const DEFAULT_USER_PERMISSIONS: UserPermissions = ALL_PERMISSION_KEYS.reduce(
  (acc, key) => {
    acc[key] = false;
    return acc;
  },
  {} as UserPermissions
);

export const DEFAULT_CREATE_USER_PERMISSIONS: UserPermissions = {
  ...DEFAULT_USER_PERMISSIONS,
  tasks: true,
};

export function mergePartialPermissions(
  partial: unknown
): UserPermissions {
  if (!partial || typeof partial !== "object" || Array.isArray(partial)) {
    return DEFAULT_USER_PERMISSIONS;
  }
  return {
    ...DEFAULT_USER_PERMISSIONS,
    ...(partial as Record<string, boolean>),
  };
}

export const FULL_ACCESS_SESSION_PERMISSIONS: UserPermissions =
  ALL_PERMISSION_KEYS.reduce((acc, key) => {
    acc[key] = key === "user_management" ? false : true;
    return acc;
  }, {} as UserPermissions);

export const FULL_ACCESS_USER_TYPES = ["owner", "app_admin"];

export function mergeFullAccessSessionPermissions(
  partial: unknown
): UserPermissions {
  const stored = mergePartialPermissions(partial);
  return {
    ...FULL_ACCESS_SESSION_PERMISSIONS,
    account_settlement_gst_delete: stored.account_settlement_gst_delete,
    account_settlement_cp_delete: stored.account_settlement_cp_delete,
    drive: stored.drive,
  };
}

export function mergeSessionPermissions(
  userType: string | null | undefined,
  partial: unknown
): UserPermissions {
  return FULL_ACCESS_USER_TYPES.includes(userType || "")
    ? mergeFullAccessSessionPermissions(partial)
    : mergePartialPermissions(partial);
}
